import { isMenu as _isMenu, Menu } from "@bw/apis/contentful";
import { Entry } from "contentful";
import { BlockType } from "../../factories/types";

// "Required" utility type
type R<T> = {} & T;

export type HeaderNavItem = R<R<BlockType<'header'>['fields']['navigation']>[number]>;

export function isMenu(entry: Entry | undefined | null): entry is Menu<"WITHOUT_UNRESOLVABLE_LINKS"> {
  return (entry != null) && _isMenu(entry);
}
